module.exports = __webpack_public_path__ + "static/media/header_image_02.41a8f130.jpg";